var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "elementType": "section",
      "customClass": "swatches-view swatches-view-wrapper"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "swatches-view-header"
    },
    on: {
      "click": function click($event) {
        return _vm.hideSplashPage();
      }
    }
  }, [_vm._t("buybutton"), _c('CustomContainer', {
    attrs: {
      "customClass": "swatches-view-header-wrapper"
    }
  }, [_vm._t("navigation")], 2), _c('swatchTabs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isAtomicEnabled,
      expression: "isAtomicEnabled"
    }],
    attrs: {
      "tabs": _vm.swatchTabsMetadata
    }
  })], 2), _vm._l(_vm.getTabsSwatches, function (groupsToRender, name) {
    return _c('swatches-wrapper', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.activeUGCOption && _vm.activeGroup === name && _vm.activeGroup !== 'yourcolors',
        expression: "!activeUGCOption && activeGroup === name && activeGroup !== 'yourcolors'"
      }],
      key: name,
      class: [name + '-container'],
      attrs: {
        "swatchesToRender": groupsToRender.subgroups,
        "groupName": name,
        "activeGroup": _vm.activeGroup
      },
      on: {
        "click": function click($event) {
          return _vm.hideSplashPage();
        }
      }
    });
  }), _vm.isUGCEnabled || _vm.configuration.vct_settings.pattern_maker.enabled || _vm.configuration.vct_settings.custom_checkerboard.enabled ? [_c('ugc-tray-wrapper', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeUGCOption,
      expression: "activeUGCOption"
    }],
    attrs: {
      "init": _vm.activeUGCOption
    }
  })] : _vm._e(), _vm.getGroupTabs['yourcolors'] ? _c('pick-your-own-color-tray', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeGroup === 'yourcolors',
      expression: "activeGroup === 'yourcolors'"
    }]
  }) : _vm._e(), _c('palettes'), _c('palette-modal'), _c('feature-tab-modal')], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }